export class MemberLevelInfo{
    level:string;
    levelId:string;
    date:string;
    memberType:string;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/member-level-info.ts